import { fieldValueSources } from 'serviceWorker/services/fieldValues/fieldValueSources';
import { fieldValuesCreator } from 'serviceWorker/services/fieldValues/createFieldValues';
import { fieldValuesChanger } from 'serviceWorker/services/fieldValues/editFieldValues';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { fieldValueEntityNames, fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { fieldValuesContract } from 'shared/domain/fieldValue/fieldValuesContract';
import { serveEntityRequests } from './serveEntityRequests';

/** Answers the requests of every field value dictionary and of field value changes. */
export function serveFieldValueRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    ...fieldValueEntityNames.map((entityName) =>
      serveEntityRequests(fieldValueContracts[entityName], fieldValueSources[entityName])
    ),
    channelServer.handle(fieldValuesContract, {
      create: ({ fieldName, fieldValues }) => fieldValuesCreator.execute(fieldName, fieldValues),
      edit: ({ fieldName, fieldValues }) => fieldValuesChanger.execute(fieldName, fieldValues),
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
